module.exports = __webpack_public_path__ + "mainassets/img/whatsapp.75fe67a9.svg";